export default __webpack_public_path__ + "static/media/3b43660653f31da6dfd41b7d40f6daae1579012472761.1fbefda2.webp";